import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/personalData/findAll')
    return data
  },

  async findByCurrentUser() {
    const { data } = await repository.get(baseURL + '/personalData/findByCurrentUser')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/personalData', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/personalData', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/personalData/' + id)
  }
}
